import { Serializer, Deserializer } from 'jsonapi-serializer';
import { JsonApiResource, JsonApiResponse } from 'types/store/jsonApi';
import { UndoBulkOperationResponse } from 'api/tasksList';
import { RootState } from 'state/store';
import { selectUserEmail, selectOrganizationId } from 'state/User/userSlice';
import { Userpilot } from 'userpilot';
import { USERPILOT_EVENTS } from 'utils/constants';

export const serializeUndoBulkOperationRequestBody = (
  eventType: 'delete' | 'update',
  operationId: string
): JsonApiResource<{ eventType: 'delete' | 'update'; operationId: string }> => {
  return new Serializer('undo-task-events', {
    id: 'id',
    attributes: ['eventType', 'operationId'],
    pluralizeType: false,
    keyForAttribute: 'camelCase',
  }).serialize({ eventType, operationId });
};

export const deserializeUndoBulkOperationResponse = (
  response: JsonApiResponse<UndoBulkOperationResponse>
) => {
  return new Deserializer({
    keyForAttribute: 'camelCase',
    transform: (record: UndoBulkOperationResponse) => {
      return record;
    },
  }).deserialize(response) as unknown as Promise<UndoBulkOperationResponse>;
};

export const trackUndoBulkOperationEvent = (
  state: RootState,
  response: UndoBulkOperationResponse,
  bulkActionOperationId: string,
  bulkActionOperationType: 'delete' | 'update',
  projectId: string
) => {
  const userEmail = selectUserEmail(state);
  const organizationId = selectOrganizationId(state);
  let eventName = '';
  if (bulkActionOperationType === 'delete') {
    eventName = USERPILOT_EVENTS.TASK_BULK_DELETE_UNDO;
  } else {
    eventName = USERPILOT_EVENTS.TASK_BULK_ASSIGN_UNDO;
  }
  Userpilot.track(eventName, {
    email: userEmail,
    companyId: organizationId,
    projectId,
    operationId: bulkActionOperationId,
    successfulCount: response.successfulCount,
    failedCount: response.failedCount,
    totalCount: response.successfulCount + response.failedCount,
  });
};
